import {baseInstance} from './baseInstance';

export const appointmentsApi = {
        getAll: () => baseInstance.get(`/appointments`),
        update: (id, data) => baseInstance.put(`/appointments/${id}`, data),
        removeUser: (id, user) => baseInstance.delete(`/appointments/${id}/assignees/${user}`),
        addUser: (id, user) => baseInstance.post(`/appointments/${id}/assignees/${user}`),
}